import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthUtils } from "../features/auth";
import { ROUTES } from "./paths";

/**
 * Everything behind this needs a session. There is no timer on one — it lasts
 * until it is ended at the sign-out button, or a request finds the refresh
 * token underneath it no longer good, at which point it fails like any other
 * request would. Where somebody was heading is remembered in router state, so
 * signing in lands them there rather than on the dashboard.
 */
export const RequireAuth: React.FC = () => {
  const location = useLocation();

  if (!AuthUtils.isSessionValid()) {
    return (
      <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet />;
};

/**
 * The sign-in screens, closed to anyone who already has a session.
 *
 * Without this, a signed-in admin who hits Back far enough lands on a login
 * card asking for a password they have already given.
 */
export const RedirectIfSignedIn: React.FC = () => {
  if (AuthUtils.isSessionValid()) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }

  return <Outlet />;
};
